<app-loader [loading]="isLoading"></app-loader>
<mat-tab-group class="dynamic-body" (selectedTabChange)="selectLanguage($event.index)" *ngIf="!isLoading">
  <ng-container *ngIf="consumer">
    <mat-tab *ngFor="let language of selectedLanguages">
      <ng-template mat-tab-label>
        <ng-container [ngTemplateOutlet]="tabLabelTemplate" [ngTemplateOutletContext]="{language: language}"></ng-container>
      </ng-template>
      <ng-container [ngTemplateOutlet]="tabContentTemplate" [ngTemplateOutletContext]="{language: language, langIndex: getLangIndex(language)}"></ng-container>
    </mat-tab>
  </ng-container>
  <ng-container *ngIf="!consumer">
    <mat-tab *ngFor="let language of sortedLanguages; let langIndex = index">
      <ng-template mat-tab-label>
        <mat-checkbox class="right-spacer-half"
                      [disabled]="language === authService.salesPointLanguage || disableCheckboxes" [checked]="selectedLanguages.includes(language)"
                      (click)="$event.stopPropagation()" (change)="toggleLanguage(language)"></mat-checkbox>
        <ng-container [ngTemplateOutlet]="tabLabelTemplate" [ngTemplateOutletContext]="{language: language}"></ng-container>
      </ng-template>
      <ng-container [ngTemplateOutlet]="tabContentTemplate" [ngTemplateOutletContext]="{language: language, langIndex: langIndex}"></ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<ng-template #tabLabelTemplate let-language="language">
  <span [ngClass]="{'text-disabled': !selectedLanguages.includes(language)}">
    {{ ('general.api_translations_table_lang_' + language) | translate }}
    <span class="text-warning" *ngIf="primaryRequired && language === authService.salesPointLanguage && !consumer">*</span>
  </span>
</ng-template>

<ng-template #tabContentTemplate let-language="language" let-langIndex="langIndex">
  <ng-container *ngFor="let field of fields; let first = first">
    <ng-container *ngIf="field.translations[langIndex]">
      <app-text-input *ngIf="field.type === EditorType.Text || field.type === EditorType.TextArea"
                      [appClass]="{'top-spacer': true}"
                      [label]="field.label" [type]="field.type === 'textarea' ? TextInputType.Textarea : TextInputType.Text"
                      [(value)]="field.translations[langIndex].value" (valueChange)="valueChanges.emit()"
                      [max]="field.maxLength" [required]="field.required(language)" [disabled]="field.disabled"></app-text-input>
      <app-text-editor *ngIf="field.type === EditorType.RichText" class="bottom-spacer"
                       [label]="field.label" [placeholder]="field.placeholder"
                       [(model)]="field.translations[langIndex].value" (modelChanged)="valueChanges.emit()"
                       [id]="field.name + '_' + langIndex"
                       [valid]="isValueValid(field.translations[langIndex].value, field.maxLength)"
                       [error]="(field.required && !field.translations[langIndex].value?.length) ? (field.label + '_can_not_be_empty') : (field.label + '_too_long')"
                       [max]="field.maxLength" [required]="field.required(language)" [disabled]="field.disabled"
                       [(inputDirty)]="field.dirty"></app-text-editor>
    </ng-container>
  </ng-container>
</ng-template>
